import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — resets the browser scroll position to the top whenever
 * the route (pathname) changes. Mounted once inside the top-level Router
 * so it applies to every navigation.
 *
 * Fixes the iter58 UX issue where clicking "Learn More" (For Private
 * Clubs) or "Become a Vendor" from the home-page Solutions section
 * loaded the destination page with the previous scroll offset instead
 * of the top of the new page.
 *
 * Skips the reset when the destination has a hash (e.g. #why-clubs-choose)
 * so the native browser anchor-scroll can do its job.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
